import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { Pagination } from '@lt/components';

import ReviewsItem from '../../../../../components/Reviews/ReviewsItem';

import {
  REVEIW_MAX_HEIGHT,
  REVEIW_MAX_CONTENT_LENGTH,
  REVEIW_MAX_HEIGHT_MOBILE,
  REVEIW_MAX_CONTENT_LENGTH_MOBILE,
} from '../../../constants';

import type { PropsFromRedux as IReviewsLevelTravel } from '.';

const baseCls = 'lt-hotel-reviews';

export const ReviewsLevelTravel = (props: IReviewsLevelTravel) => {
  const { items, isMobile, pagesCount, currentPage, linkBase } = props;
  const { t } = useTranslation();

  return items?.length ? (
    <>
      {items.map(({ author_id, ...item }) => (
        <ReviewsItem
          {...item}
          key={author_id}
          maxContainerHeight={
            isMobile ? REVEIW_MAX_HEIGHT_MOBILE : REVEIW_MAX_HEIGHT
          }
          maxContentLength={
            isMobile
              ? REVEIW_MAX_CONTENT_LENGTH_MOBILE
              : REVEIW_MAX_CONTENT_LENGTH
          }
          showDate
        />
      ))}

      <StyledPagination
        pagesCount={pagesCount}
        currentPage={currentPage}
        length={pagesCount < 5 ? pagesCount : 5}
        linkBase={linkBase}
      />
    </>
  ) : (
    <div className={`${baseCls}__empty`}>{t('hotel.reviews.emptyTitleLT')}</div>
  );
};

const StyledPagination = styled(Pagination)`
  margin-top: 16px;
`;
